<template>
  <div class="order-facet-fi">
    <template v-if="facet.type === 'search'">
      <search-facet-fi
        :facet="facet"
        @change="onChange"
      />
    </template>

    <select-fi
      v-else
      :elements="facet.elements"
      :name="facet.name"
      :multiselect="facet.multiselect"
      :open="open"
      large
      @change="onChange"
      @toggle-open="onToggleOpen(facet)"
      @close="onClose(facet)"
    />
  </div>
</template>

<script>
import { SelectFi } from 'atoms';
import SearchFacetFi from 'components/facets/search-facet-fi/SearchFacetFi';
import breakpointMixin from 'mixins/breakpointMixin';
import dateMixin from 'mixins/dateMixin';

export default {
  name: 'DocumentDownloadFacetFi',
  components: {
    SelectFi,
    SearchFacetFi,
  },
  mixins: [breakpointMixin, dateMixin],
  props: {
    facet: {
      type: Object,
      required: true,
    },
    open: {
      type: Boolean,
    },
    idx: {
      type: Number,
      default: null,
    },
    registerDomElement: {
      type: Function,
      default: null,
    },
  },
  emits: ['change', 'close', 'toggle-open'],
  data() {
    return {
      wrapperStyle: {},
      internalOpen: false,
    };
  },
  watch: {
    idx(newValue) {
      this.registerElement(newValue);
    },
  },
  mounted() {
    this.registerElement(this.idx);
  },
  methods: {
    registerElement(idx) {
      if (idx === 0 && this.registerDomElement) {
        this.registerDomElement(this.$el);
      }
    },
    onClose() {
      if (this.open) {
        this.onToggleOpen();
      }
      this.$emit('close');
    },
    onToggleOpen() {
      this.$emit('toggle-open');
    },
    onChange(...params) {
      this.$emit('change', ...params);
    },
  },
};
</script>
